export default __webpack_public_path__ + "static/media/MRS.a57496fc.dmg";